// Google OAuth Configuration
const googleConfig = {
  clientId: '704412310446-buaorqqfn85pflndi3cdcmiclc4i68so.apps.googleusercontent.com',
  redirectUri: 'https://vi.smartera.uk/auth/google/callback',
  scope: 'openid email profile',
};

export default googleConfig;
